import { CART_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { IWhatsappTemplateParams, IWhatsappTemplateResponse } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});

type WhatsappTemplateResult =
  | { status: true; data: IWhatsappTemplateResponse }
  | { status: false; message: string };

export const useWhatsappTemplateAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (params: IWhatsappTemplateParams): Promise<WhatsappTemplateResult | undefined> => {
      dispatch(
        setLoading({
          key: "isvaccinationTableLoading",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: WhatsappTemplateResult = await axios
          .get(`${CART_MODULE?.HD_WHATSAPP_TEMPLATE?.baseURL}`, {
            params,
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IWhatsappTemplateResponse>) => {
            dispatch(
              setLoading({
                key: "isvaccinationTableLoading",
                status: false,
              }),
            );
            if (res.status === 200 && res.data?.template_content) {
              return { status: true as const, data: res.data };
            }
            return { status: false as const, message: "template_not_found" };
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            dispatch(
              setLoading({
                key: "isvaccinationTableLoading",
                status: false,
              }),
            );
            captureError(e);
            return { status: false as const, message: "template_fetch_failed" };
          });
        return response;
      } catch (e: any) {
        dispatch(
          setLoading({
            key: "isvaccinationTableLoading",
            status: false,
          }),
        );
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { execute };
};
